import actionTypes from 'SRC/modules/redux/actionTypes'

export const setIsAuthorized = (isAuthorized = false) => ({
  type: actionTypes.SET_IS_AUTHORIZED_USER,
  payload: isAuthorized
})
